import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { throwError, Observable } from 'rxjs';
import { environment } from '../environments/environment.prod';
import { AuthService } from './common_service/auth.service';

@Injectable({
  providedIn: 'root',
})
export class HttpService {
  private readonly _getContent = new Map<any, Observable<any>>();
  baseUrl = environment.port;
  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) { }

  get(url) {
    return this.http.get(url).pipe(map(res => {
      return res;
    })).pipe(catchError(err => {
      return this.unauthorisedUserErr(err)
    }))
  }
  post(url, postBody: any) {
    return this.http.post(url, postBody)
      .pipe(map(res => res))
      .pipe(catchError(err => {
        return this.unauthorisedUserErr(err)
      }))
  }
  delete(url, options = null) {
    if(options) {
      return this.http.delete(url, options)
      .pipe(map(res => res))
      .pipe(catchError(err => {
        return this.unauthorisedUserErr(err)
      }))
    }
    else {
      return this.http.delete(url)
      .pipe(map(res => res))
      .pipe(catchError(err => {
        return this.unauthorisedUserErr(err)
      }))
    }
  }
  put(url, putData = null) {
    return this.http.put(url, putData)
      .pipe(map(res => res))
      .pipe(catchError(err => {
        return this.unauthorisedUserErr(err)
      }))
  }
  patch(url, patchtData) {
    return this.http.put(url, patchtData).pipe(map(res => res)).pipe(catchError(this.onError))
      .pipe(map(res => res))
      .pipe(catchError(err => {
        return this.unauthorisedUserErr(err)
      }))
  }
  unauthorisedUserErr(err) {
    if (err?.error?.message === "Unauthorized user") {
      return this.authService.redirectToPingIdLogin();
    } else {
      return throwError(err);
    }
  }
  onError(errorResponse: any) {
    return throwError(errorResponse);
  }
}
